import { useEffect } from 'react';

/**
 * Keep the document's `<html lang>` attribute in sync with the active language.
 *
 * Drives language-scoped CSS — notably the zh-TW Huninn font override in
 * `src/style.css` (`:root[lang="zh-TW"]`) — and improves accessibility/SEO.
 * Tracks the live i18n language (including the unapplied Settings preview),
 * not the persisted value.
 */
export function useHtmlLang(lang: string): void {
    useEffect(() => {
        document.documentElement.lang = lang;
    }, [lang]);
}
